import {Model} from 'vue-mc';

export class ClientDashboardModel extends Model {

	// Default attributes that define the "empty" state.
	defaults() {
		return {
			id: 0
		}
	}
}



// WEBPACK FOOTER //
// ./src/models/clientDashboardModel.js